{
  "lastUpdatedAt": "2026-07-27T15:29:18.335Z",
  "lastFetchAttemptAt": "2026-07-27T15:29:18.335Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}